const brCurrency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatPrice = (price: number) =>
  brCurrency.format(price).replace(/R\$\s/, '');
